export type ContentGender = 'man' | 'woman' | 'neutral';

export enum AllowedDirectoryVideoTypes {
  Spalla = 'spalla',
  File = 'file',
}

export const AllowedDirectoryVideoTypesLabels: Record<
  AllowedDirectoryVideoTypes,
  string
> = {
  [AllowedDirectoryVideoTypes.Spalla]: 'Spalla',
  [AllowedDirectoryVideoTypes.File]: 'Arquivo',
};

export enum AllowedFileTypes {
  Video = 'video',
  Image = 'image',
  Audio = 'audio',
  PDF = 'pdf',
  EBook = 'ebook',
  Link = 'link',
  Document = 'doc',
  CSV = 'csv',
}

export const AllowedFileTypesLabels: Record<AllowedFileTypes, string> = {
  [AllowedFileTypes.Video]: 'Vídeo',
  [AllowedFileTypes.Image]: 'Imagem',
  [AllowedFileTypes.Audio]: 'Áudio',
  [AllowedFileTypes.PDF]: 'PDF',
  [AllowedFileTypes.EBook]: 'E-Book',
  [AllowedFileTypes.Link]: 'Link',
  [AllowedFileTypes.Document]: 'Documento',
  [AllowedFileTypes.CSV]: 'CSV',
};

export enum S3ImagePaths {
  'thumb.web.neutral' = 'thumb/web/neutral.png',
  'thumb.web.female' = 'thumb/web/female.png',
  'thumb.web.male' = 'thumb/web/male.png',

  'thumb.mobile.neutral' = 'thumb/mobile/neutral.png',
  'thumb.mobile.female' = 'thumb/mobile/female.png',
  'thumb.mobile.male' = 'thumb/mobile/male.png',

  'thumb.tv.neutral' = 'thumb/tv/neutral.png',
  'thumb.tv.female' = 'thumb/tv/female.png',
  'thumb.tv.male' = 'thumb/tv/male.png',

  'logotipo.neutral' = 'logotipo/neutral.png',
  'logotipo.female' = 'logotipo/female.png',
  'logotipo.male' = 'logotipo/male.png',

  'bannerInterno.web.neutral' = 'bannerInterno/web/neutral.png',
  'bannerInterno.web.female' = 'bannerInterno/web/female.png',
  'bannerInterno.web.male' = 'bannerInterno/web/male.png',

  'bannerInterno.tv.neutral' = 'bannerInterno/tv/neutral.png',
  'bannerInterno.tv.female' = 'bannerInterno/tv/female.png',
  'bannerInterno.tv.male' = 'bannerInterno/tv/male.png',

  'bannerInterno.mobileApp.neutral' = 'bannerInterno/mobileApp/neutral.png',
  'bannerInterno.mobileApp.female' = 'bannerInterno/mobileApp/female.png',
  'bannerInterno.mobileApp.male' = 'bannerInterno/mobileApp/male.png',

  'bannerInterno.tablet.neutral' = 'bannerInterno/tablet/neutral.png',
  'bannerInterno.tablet.female' = 'bannerInterno/tablet/female.png',
  'bannerInterno.tablet.male' = 'bannerInterno/tablet/male.png',

  'bannerQuiz.web.neutral' = 'bannerQuiz/web/neutral.png',
  'bannerQuiz.web.female' = 'bannerQuiz/web/female.png',
  'bannerQuiz.web.male' = 'bannerQuiz/web/male.png',

  'bannerQuiz.appResponsive.neutral' = 'bannerQuiz/appResponsive/neutral.png',
  'bannerQuiz.appResponsive.female' = 'bannerQuiz/appResponsive/female.png',
  'bannerQuiz.appResponsive.male' = 'bannerQuiz/appResponsive/male.png',
}
